import React from 'react';
import ReactDOM from 'react-dom';
import $ from 'jquery';
import { Router, Route } from 'react-router-dom';
import { IntlProvider } from 'react-intl';
import { FluxibleComponent } from 'fluxible-addons-react';
import ddo from '@99designs/ddo/index';
import models from 'apps/designdetails/di';
import Fluxible from 'fluxible';
import FavoriteDesignerStore from 'apps/favorite-designer/FavoriteDesignerStore';
import OnlineStatusStore from 'stores/OnlineStatusStore';
import DesignDetailsSidebar from 'apps/designdetails/components/DesignDetailsSidebar';
import history from 'utils/history';

document.addEventListener('DOMContentLoaded', () => {
    const appNode = document.getElementById('design-details-app');
    const reactDataNode = document.querySelector('[data-details-react-data]');
    const intl = JSON.parse(reactDataNode.getAttribute('data-details-translation-map'));
    const favoriteDesignerIntlData = JSON.parse(reactDataNode.getAttribute('data-favorite-designer-translation-map'));
    const activeUser = JSON.parse(reactDataNode.getAttribute('data-details-active-user'));
    const ddoPath = '/profiles/:parentId/designs/:designId';
    const csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute('content');
    const NoOpComponent = () => null;

    intl.messages = Object.assign({}, intl.messages, favoriteDesignerIntlData.messages);

    window.REQUEST_TOKENS = {
        DESIGN_COMMENT_CREATE_FINISH: csrfToken,
        DESIGN_COMMENT_DELETE_FINISH: csrfToken,
        DESIGN_COMMENT_UPDATE: csrfToken,
        DESIGN_UPDATE_LIKE_STATUS: csrfToken,
    };

    const fluxibleApp = new Fluxible({
        stores: [
            OnlineStatusStore,
            FavoriteDesignerStore,
        ],
    });

    const fluxibleContext = fluxibleApp.createContext();

    const { DdoComponent, setDesignCollection } = ddo({
        fluxibleApp,
        fluxibleContext,
        activeUser,
        isInline: true,
        models,
        goBack: () => {
            history.go(-1);
        },
        goTo: (path) => {
            history.replace(path);
        },
        csrfToken: document.querySelector('meta[name=csrf-token]').getAttribute('content'),
    });

    $(document).on('click', '[data-design-details-item]', function (e) {
        if (e.metaKey || e.ctrlKey) {
            return true;
        }

        e.preventDefault();

        const designsHalJson = JSON.parse(document.querySelector('[data-designs-hal-json]').getAttribute('data-designs-hal-json')) || {};
        const targetUrl = $(this).attr('href');

        return setDesignCollection(models.designCollection.fromJSON(designsHalJson))
            .then(() => history.push(targetUrl));
    });

    ReactDOM.render(
        <IntlProvider {...intl}>
            <FluxibleComponent context={fluxibleContext.getComponentContext()}>
                <Router history={history}>
                    <div>
                        <Route
                            path={ddoPath}
                            component={props => (
                                <DdoComponent
                                    designId={props.match.params.designId}
                                    renderSidebar={sidebarProps => (
                                        <DesignDetailsSidebar
                                            activeUser={activeUser}
                                            {...sidebarProps}
                                        />
                                    )}
                                />
                            )}
                        />
                        <NoOpComponent path="*" />
                    </div>
                </Router>
            </FluxibleComponent>
        </IntlProvider>,
        appNode,
    );
});



// WEBPACK FOOTER //
// ./src/js/page/inline-ddo.jsx